// src/pages/ThemeSettingsPage.jsx
import React, { useEffect, useState } from "react";
import api from "../../axiosConfig";

const ThemeSettingsPage = () => {
  const [colorPrimario, setColorPrimario] = useState("#000000");
  const [colorFondo, setColorFondo] = useState("#FFFFFF");

  const [modificologoPrimario, setModificologoPrimario] = useState(false);
   

  const [previewLogoUrl, setPreviewLogoUrl] = useState("assets/images/auth/logo.png");
  const [logoBase64, setLogoBase64] = useState(null);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Cargar tema actual
  useEffect(() => {
    const fetchPerfil = async () => {
      try {
        setLoading(true);
        setError("");
        const res = await api.get("/perfil", {
          headers: { "X-Skip-Auth-Redirect": "true" },
        });

        if (res.status === 200 && res.data) {
          const theme = res.data;

          if (theme.colorPrimario) {
            setColorPrimario(theme.colorPrimario);
          }
          if (theme.colorFondo) {
            setColorFondo(theme.colorFondo);
          }
          if (theme.logoPrimario) {
            setPreviewLogoUrl(theme.logoPrimario);
          }
        } else {
          setError("No se pudo cargar el tema de la plataforma.");
        }
      } catch (err) {
        console.error(err);
        setError("Ocurrió un error al cargar el tema.");
      } finally {
        setLoading(false);
      }
    };

    fetchPerfil();
  }, []);

  // Utilidad para manejar cambio de archivo y convertir a base64
  const handleLogoChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    setModificologoPrimario(true)
    reader.onloadend = () => {
      const result = reader.result || "";
      // result = "data:image/png;base64,AAAA..."
      const base64Only = result.toString().split(",")[1];
      setLogoBase64(base64Only);
      // Para el preview usamos el dataURL completo
      setPreviewLogoUrl(result);
    };
    reader.readAsDataURL(file);
  };

  const handleSave = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setSaving(true);
    setError("");
    setSuccess("");

    try {
      const payload = {
        colorPrimario,
        colorFondo,
        modificologoPrimario
      };

      if (logoBase64) {
        payload.baselogoPrimario = logoBase64;
      }

      const res = await api.put("/perfil/1", payload, {
        headers: { "X-Skip-Auth-Redirect": "true" },
      });

      if (res.status >= 200 && res.status < 300) {
        setSuccess("Tema actualizado correctamente.");
        // Opcional: actualizar CSS vars globales para ver el cambio al vuelo
        document.documentElement.style.setProperty("--primary-600", colorPrimario);
        document.documentElement.style.setProperty("--primary-700", colorPrimario);
        document.documentElement.style.setProperty("--primary-50", colorPrimario);
        document.documentElement.style.setProperty("--neutral-50", colorFondo);

        const theme = res.data;

        document.documentElement.style.setProperty("portal_logo_url", theme.logoPrimario  );


        
          if (theme.colorPrimario){
             localStorage.setItem("color_primario", theme.colorPrimario);
          }

          if (theme.colorFondo){ 
             localStorage.setItem("color_fondo", theme.colorFondo);
          }

          if (theme.logoPrimario) {
             localStorage.setItem("portal_logo_url", theme.logoPrimario);
           }


      } else {
        setError("No se pudo guardar el tema. Intenta de nuevo.");
      }
    } catch (err) {
      console.error(err);
      setError("Ocurrió un error al guardar el tema.");
    } finally {
      setSaving(false);
    }
  };

  // Estilos rápidos para el preview
  const previewWrapperStyle = {
    backgroundColor: colorFondo,
    minHeight: "100%",
    borderRadius: "16px",
    padding: "32px",
    border: "1px solid #e5e7eb",
  };

  const primaryButtonStyle = {
    backgroundColor: colorPrimario,
    borderColor: colorPrimario,
    color: "#ffffff",
  };

  const primaryTextStyle = {
    color: colorPrimario,
  };

  return (
    <>
      
      <p className="text-muted mb-4">
        Configura los colores y el logo que se utilizarán en toda la plataforma del Portal del Trabajador.
      </p>

      {loading && <div className="alert alert-info">Cargando tema actual...</div>}
      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <div className="row mt-4">
        {/* Columna izquierda: formulario */}
        <div className="col-lg-5 mb-4">
          <div className="card shadow-sm border-0">
            <div className="card-body">
              <h5 className="card-title mb-3">Configuración</h5>
              <form onSubmit={handleSave}>
                {/* Color primario */}
                <div className="mb-3">
                  <label className="form-label fw-semibold">Color primario</label>
                  <div className="d-flex align-items-center gap-2">
                    <input
                      type="color"
                      className="form-control form-control-color p-1"
                      value={colorPrimario}
                      onChange={(e) => setColorPrimario(e.target.value)}
                      title="Selecciona el color primario"
                    />
                    <input
                      type="text"
                      className="form-control"
                      value={colorPrimario}
                      onChange={(e) => setColorPrimario(e.target.value)}
                      placeholder="#000000"
                    />
                  </div>
                  <div className="form-text">
                    Se usará para botones, enlaces principales y títulos destacados.
                  </div>
                </div>

                {/* Color de fondo */}
                <div className="mb-3">
                  <label className="form-label fw-semibold">Color de fondo</label>
                  <div className="d-flex align-items-center gap-2">
                    <input
                      type="color"
                      className="form-control form-control-color p-1"
                      value={colorFondo}
                      onChange={(e) => setColorFondo(e.target.value)}
                      title="Selecciona el color de fondo"
                    />
                    <input
                      type="text"
                      className="form-control"
                      value={colorFondo}
                      onChange={(e) => setColorFondo(e.target.value)}
                      placeholder="#FFFFFF"
                    />
                  </div>
                  <div className="form-text">
                    Se usará como fondo principal de la plataforma.
                  </div>
                </div>

                {/* Logo */}
                <div className="mb-3">
                  <label className="form-label fw-semibold">Logo de la plataforma</label>
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={handleLogoChange}
                  />
                  <div className="form-text">
                    Si seleccionas un nuevo logo de  <code>130 x 130</code> y png.
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100 mt-3"
                  style={primaryButtonStyle}
                  disabled={saving}
                >
                  {saving ? "Guardando..." : "Guardar cambios"}
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Columna derecha: preview */}
        <div className="col-lg-7">
          <div style={previewWrapperStyle}>
            <div className="row g-4 align-items-center">
              <div className="col-md-6 d-none d-md-flex justify-content-center">
                <img
                  src="assets/images/auth/auth-img.png"
                  alt="Ejemplo de la plataforma"
                  className="img-fluid"
                  style={{ maxHeight: "260px" }}
                />
              </div>
              <div className="col-md-6">
                <div className="text-center mb-4">
                  <img
                    src={previewLogoUrl}
                    alt="Logo preview"
                    style={{ maxHeight: "70px", objectFit: "contain" }}
                  />
                  <h5 className="mt-3 mb-1" style={primaryTextStyle}>
                    Portal del Trabajador
                  </h5>
                  <p className="text-muted mb-0">Vista previa de inicio de sesión</p>
                </div>

                <div className="mb-3 text-start">
                  <label className="form-label small">RFC</label>
                  <input
                    type="text"
                    className="form-control"
                    disabled
                    placeholder="ABC123456XYZ"
                  />
                </div>
                <div className="mb-3 text-start">
                  <label className="form-label small">Contraseña</label>
                  <input
                    type="password"
                    className="form-control"
                    disabled
                    placeholder="••••••••"
                  />
                </div>
                <button
                  type="button"
                  className="btn w-100"
                  style={primaryButtonStyle}
                  disabled
                >
                  Iniciar sesión
                </button>
                <p className="mt-3 text-center text-muted small mb-0">
                  Así se verá la pantalla usando los colores y logo seleccionados.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThemeSettingsPage;